// extracted by mini-css-extract-plugin
export default {"wrapperList":"InfoAboutUs_wrapperList__HMWUx"};